import { UpdateBasicInfo } from "../../app/data/terminal-details/models";

export interface UpdateBasicInfoState {
    data: UpdateBasicInfo | null;  
    isLoading: boolean;
    isSuccess: boolean;
    isError: boolean;
    errorMessage?: string | null;
}

export const initialUpdateBasicInfoState: UpdateBasicInfoState = {
    data: null,
    isLoading: false,
    isSuccess: false,
    isError: false,
    errorMessage: null
};
  